/* Cendre & Braise : effets (flamme, braises). Moteur repris tel quel de emberwing.min.js.
   Dépend de window.EW.images et de window.EWFx.key() (clé "dragon-flamme" du dragon actif, fournie par emberwing-app.js). */
(function () {
  var EW = window.EW || { variants: [], images: {} };
  var POS = {
    "or-orange": { mouth: [55.1, 51.4], base: [28, 85] },
    "or-bleu": { mouth: [56.2, 51], base: [28, 84] },
    "noir-bleu": { mouth: [58.6, 47.9], base: [30, 84] },
    "noir-orange": { mouth: [55.5, 49.1], base: [27, 83] }
  };
  var n = {};
  Object.keys(POS).forEach(function (k) {
    n[k] = { mouth: POS[k].mouth, base: POS[k].base };
  });
  var s = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var Fx = (window.EWFx = window.EWFx || {});
  Fx.pos = n;
  Fx.instances = [];
  Fx.reduced = s;
  Fx.key = Fx.key || function () { return "noir-orange"; };
  function c() { return Fx.key(); }

  function A(t, e, n2) {
    var a = 128, o = document.createElement("canvas");
    o.width = o.height = a;
    var r = o.getContext("2d"), i = r.createRadialGradient(64, 64, 0, 64, 64, 64);
    i.addColorStop(0, "rgba(" + t + ",1)");
    i.addColorStop(.16, "rgba(" + t + ",.85)");
    i.addColorStop(.38, "rgba(" + e + ",.6)");
    i.addColorStop(.68, "rgba(" + n2 + ",.2)");
    i.addColorStop(1, "rgba(" + n2 + ",0)");
    r.fillStyle = i; r.fillRect(0, 0, a, a);
    return o;
  }
  var S = {
    orange: { hot: A("255,246,210", "255,172,52", "255,92,12"), cool: A("255,150,40", "255,78,10", "170,28,0") },
    bleu: { hot: A("234,249,255", "112,192,255", "40,112,255"), cool: A("122,192,255", "50,120,255", "20,50,200") }
  };
  var O = { orange: "255,140,50", bleu: "110,190,255" };

  function R(t, e, a, o) {
    o = o || {};
    var r = e.getContext("2d"), i = 0, d = 0, l = 1, u = [], f = [], m = false, h = true, v = 0, g = 0, y = 0, b = 0,
      p = { x: -999, y: -999, vx: 0, vy: 0 }, x = o.stage || null;
    function E() {
      l = Math.min(window.devicePixelRatio || 1, 2);
      var n3 = t.getBoundingClientRect();
      i = n3.width; d = n3.height;
      e.width = Math.round(i * l); e.height = Math.round(d * l);
      r.setTransform(l, 0, 0, l, 0, 0);
    }
    function M() {
      var e2 = t.getBoundingClientRect(), r2 = a.getBoundingClientRect(), i2 = n[c()] || n["noir-orange"],
        s2 = r2.left - e2.left + r2.width * i2.mouth[0] / 100,
        d2 = r2.top - e2.top + r2.height * i2.mouth[1] / 100,
        l2 = r2.left - e2.left + r2.width * (i2.base[0] + 5) / 100,
        u2 = r2.top - e2.top + r2.height * (i2.base[1] - 7) / 100,
        f2 = l2 - s2, m2 = u2 - d2, h2 = Math.sqrt(f2 * f2 + m2 * m2) || 1;
      return { mx: s2, my: d2, ex: l2, ey: u2, dx: f2 / h2, dy: m2 / h2, L: h2,
        bx: r2.left - e2.left + r2.width * i2.base[0] / 100,
        by: r2.top - e2.top + r2.height * (i2.base[1] - 6) / 100,
        k: r2.width / 560 * (o.scale || 1) };
    }
    function k(t2, e2) { return t2 + Math.random() * (e2 - t2); }
    function w(t2, e2, n2) {
      if (!(u.length > 300)) {
        var a2 = t2.k;
        if (n2) {
          var o2 = k(-2.7, -.45), r2 = k(.7, 2.1) * a2 * e2;
          u.push({ x: t2.mx + k(-2, 2) * a2, y: t2.my + k(-2, 2) * a2, vx: Math.cos(o2) * r2, vy: Math.sin(o2) * r2 - .15 * a2, s: k(6, 12) * a2, age: 0, life: k(14, 28), seed: 100 * Math.random(), t: 1 });
        } else {
          var i2 = k(24, 46), c2 = k(.25, 1) * e2, s2 = (r2 = t2.L * c2 / i2, k(-.2, .2));
          u.push({ x: t2.mx + k(-2, 2) * a2, y: t2.my + k(-2, 2) * a2, vx: (t2.dx - t2.dy * s2) * r2, vy: (t2.dy + t2.dx * s2) * r2, s: k(6, 13) * a2, age: 0, life: i2, seed: 100 * Math.random(), t: 0 });
        }
      }
    }
    function L(t2, e2, n2) {
      if (!(f.length > 140)) {
        var a2 = t2.k;
        if ("base" === e2) f.push({ x: t2.bx + k(-26, 26) * a2, y: t2.by + k(-6, 14) * a2, vx: k(-.25, .35), vy: k(-1.5, -.5) * n2, r: k(.8, 2) * Math.max(.7, a2), age: 0, life: k(70, 150), seed: 10 * Math.random() });
        else if ("beam" === e2) {
          var o2 = Math.random();
          f.push({ x: t2.mx + (t2.ex - t2.mx) * o2, y: t2.my + (t2.ey - t2.my) * o2, vx: k(-.4, .5), vy: k(-1.3, -.4) * n2, r: k(.7, 1.8) * Math.max(.7, a2), age: 0, life: k(50, 120), seed: 10 * Math.random() });
        } else f.push({ x: t2.mx, y: t2.my, vx: k(-1.4, .7) * n2, vy: k(-1.3, .9) * n2, r: k(.8, 1.9) * Math.max(.7, a2), age: 0, life: k(50, 110), seed: 10 * Math.random() });
      }
    }
    function C(t2) {
      if (m) {
        requestAnimationFrame(C);
        var e2 = Math.min(2.2, (t2 - v) / 16.67 || 1);
        if (v = t2, !(i < 2) && h) {
          var n2 = M(), a2 = t2 / 1e3 % 4.8, o2 = a2 < 1.6 ? Math.sin(a2 / 1.6 * Math.PI) : 0;
          for (x && x.style.setProperty("--breath", o2.toFixed(3)), g += (2.1 + 3.4 * o2) * e2; g >= 1;) w(n2, 1 + .25 * o2, false), g--;
          for (y += (.45 + 1.8 * o2) * e2; y >= 1;) w(n2, 1, true), y--;
          for (b += (.3 + 1.3 * o2) * e2; b >= 1;) L(n2, Math.random() < .4 ? "base" : Math.random() < .6 ? "beam" : "mouth", 1), b--;
          r.clearRect(0, 0, i, d);
          var c2 = "bleu" === document.documentElement.dataset.flame ? "bleu" : "orange", s2 = S[c2];
          r.globalCompositeOperation = "lighter";
          for (var l2 = u.length - 1; l2 >= 0; l2--) {
            var E2 = u[l2]; E2.age += e2;
            var k2 = E2.age / E2.life;
            if (k2 >= 1) u.splice(l2, 1);
            else {
              if (0 === E2.t) { var q = .045 * Math.sin(.35 * E2.age + E2.seed) * n2.k; E2.vx += -n2.dy * q * e2; E2.vy += n2.dx * q * e2; }
              else { E2.vy -= .045 * n2.k * e2; E2.vx += .05 * Math.sin(.4 * E2.age + E2.seed) * n2.k * e2; }
              var A2 = E2.x - p.x, I2 = E2.y - p.y, R2 = A2 * A2 + I2 * I2;
              if (R2 < 19600) { var P2 = .05 * (1 - Math.sqrt(R2) / 140); E2.vx += p.vx * P2 * e2; E2.vy += p.vy * P2 * e2; }
              E2.x += E2.vx * e2; E2.y += E2.vy * e2;
              var z = k2 < .1 ? k2 / .1 : Math.pow(1 - k2, 1.15), T = E2.s * (E2.t ? 1.25 - .8 * k2 : .75 + k2 * (1 - k2) * 3.2 + .35 * k2) * 1.7;
              r.globalAlpha = Math.min(1, .34 * z * (1 - .6 * k2));
              r.drawImage(s2.hot, E2.x - T / 2, E2.y - T / 2, T, T);
              if (k2 > .25) { r.globalAlpha = Math.min(1, .22 * z * k2); var F = 1.25 * T; r.drawImage(s2.cool, E2.x - F / 2, E2.y - F / 2, F, F); }
            }
          }
          for (var B = f.length - 1; B >= 0; B--) {
            var j = f[B]; j.age += e2;
            var N = j.age / j.life;
            if (N >= 1) f.splice(B, 1);
            else {
              j.vy -= .006 * e2; j.vx += .03 * Math.sin(.09 * j.age + j.seed) * e2; j.x += j.vx * e2; j.y += j.vy * e2;
              var _ = (N < .15 ? N / .15 : 1 - N) * (.7 + .3 * Math.sin(.5 * j.age + j.seed));
              r.fillStyle = "rgba(" + O[c2] + "," + .22 * _ + ")"; r.beginPath(); r.arc(j.x, j.y, 3.2 * j.r, 0, 6.283); r.fill();
              r.fillStyle = "rgba(255,236,200," + .95 * _ + ")"; r.beginPath(); r.arc(j.x, j.y, j.r, 0, 6.283); r.fill();
            }
          }
          r.globalCompositeOperation = "source-over"; r.globalAlpha = 1; p.vx *= .9; p.vy *= .9;
        }
      }
    }
    this.roar = function (t2) {
      t2 = t2 || 1;
      var e2, n2 = M(), a2 = Math.round(44 * t2);
      for (e2 = 0; e2 < a2; e2++) w(n2, 1.3, false), e2 % 2 && w(n2, 1.4, true), e2 % 3 == 0 && L(n2, "mouth", 2.2);
      for (e2 = 0; e2 < Math.round(24 * t2); e2++) L(n2, e2 % 2 ? "beam" : "base", 1.6);
      x && (x.classList.remove("roar"), x.offsetWidth, x.classList.add("roar"));
    };
    t.addEventListener("pointermove", function (e2) {
      var n2 = t.getBoundingClientRect(), a2 = e2.clientX - n2.left, o2 = e2.clientY - n2.top;
      p.x > -900 && (p.vx = .5 * (a2 - p.x), p.vy = .5 * (o2 - p.y)); p.x = a2; p.y = o2;
    });
    t.addEventListener("pointerleave", function () { p.x = p.y = -999; });
    E();
    new ResizeObserver(E).observe(t);
    new IntersectionObserver(function (t2) {
      !(h = t2[0].isIntersecting) || m || s || (m = true, v = performance.now(), requestAnimationFrame(C));
    }, { threshold: 0 }).observe(t);
    s || (m = true, v = performance.now(), requestAnimationFrame(C));
    document.addEventListener("visibilitychange", function () {
      document.hidden ? m = false : m || s || (m = true, v = performance.now(), requestAnimationFrame(C));
    });
  }
  Fx.R = R;

  /* Braises de fond (plein écran, fixes) */
  Fx.embers = function () {
    if (s) return;
    var t, e, n3, a = document.getElementById("embers"), r = a.getContext("2d"), i = [];
    l(); addEventListener("resize", l);
    for (var cnt = t < 700 ? 22 : 46, d = 0; d < cnt; d++) i.push(u(true));
    requestAnimationFrame(function loop(ts) {
      requestAnimationFrame(loop);
      if (!document.hidden) {
        r.clearRect(0, 0, t, e);
        for (var o = "bleu" === document.documentElement.dataset.flame ? "120,195,255" : "255,140,50", c2 = 0; c2 < i.length; c2++) {
          var s2 = i[c2];
          if (s2.y += s2.vy, s2.x += .35 * Math.sin(8e-4 * ts + s2.ph), s2.y < -10) i[c2] = u(false);
          else {
            var d2 = s2.a * (.6 + .4 * Math.sin(.004 * ts + s2.ph)) * Math.min(1, s2.y / (.3 * e));
            r.fillStyle = "rgba(" + o + "," + .18 * d2 + ")"; r.beginPath(); r.arc(s2.x, s2.y, 4 * s2.r, 0, 6.283); r.fill();
            r.fillStyle = "rgba(" + o + "," + d2 + ")"; r.beginPath(); r.arc(s2.x, s2.y, s2.r, 0, 6.283); r.fill();
          }
        }
      }
    });
    function l() {
      n3 = Math.min(window.devicePixelRatio || 1, 2); t = innerWidth; e = innerHeight;
      a.width = t * n3; a.height = e * n3; r.setTransform(n3, 0, 0, n3, 0, 0);
    }
    function u(first) {
      return { x: Math.random() * t, y: first ? Math.random() * e : e + 10, r: 1.7 * Math.random() + .4, vy: -(.5 * Math.random() + .15), ph: 6.28 * Math.random(), a: .6 * Math.random() + .2 };
    }
  };
})();
